import React from 'react';
import DialogFormFrame from 'Components/Forms/DialogFormFrame';
import TermsContent from '../TermsContent';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';

const TermsDialog = ({ open, onClose }) => {
  return (
    <DialogFormFrame
      title={'Terms and Conditions'}
      open={open}
      onClose={onClose}
      formComponent={<TermsContent />}
      maxSize
      actions={
        <ThemeButton onClick={onClose} color="PRIMARY" size="large">
          Close
        </ThemeButton>
      }
    />
  );
};
export default TermsDialog;
